import { useMemo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useConfigProperty } from "@leagueplatform/core";
import { useAnalyticsIdentify } from "@leagueplatform/web-common";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import { RewardsEventController } from "@leagueplatform/rewards-events";
import { BasePage } from "components/base-page/base-page.component";
import { DevToolsButton } from "components/dev-tools-button/dev-tools-button.component";
import { useGetUserProfile } from "hooks/queries/use-get-user-profile.hook";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";

export const PrivateRoutesContainer = () => {
  const { data: profile, isLoading: profileLoading } = useGetUserProfile();

  // Send user data to analytics SDK
  const tenantId = useConfigProperty("core.tenantId");
  const identifyOptions = useMemo(
    () => ({
      employer_group_id: "",
      tenant_id: tenantId!,
    }),
    [tenantId]
  );
  useAnalyticsIdentify(identifyOptions);

  if (profileLoading) return <LoadingIndicator />;

  if (profile?.ftuxComplete === false) {
    return <Navigate to={APP_MANAGED_ROUTES.ACCOUNT_SETUP} replace />;
  }

  return (
    <BasePage>
      <Outlet />
      <RewardsEventController />
      <DevToolsButton />
    </BasePage>
  );
};
